import React, { useState } from 'react';

const TextArea = ({
    value,
    onChange,
    onBlur,
    placeholder = '',
    className = '',
    error = false,
    rows = 3,
    maxLength,
    showCount = false,
    resize = true,
    ...props
}) => {
    const [charCount, setCharCount] = useState(value?.length || 0);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setCharCount(newValue.length);

        if (onChange) {
            onChange(e);
        }
    };

    const baseClasses = `
    !flex !w-full !min-w-0 !flex-1 !resize-none !overflow-hidden !rounded-xl 
    !text-[#121317] focus:!outline-0 focus:!ring-0 !border !bg-white
    !placeholder:text-[#676c83] !p-[15px] !text-base !font-normal !leading-normal
    ${!resize ? '!resize-none' : '!resize-y'}
  `;

    const borderClasses = error ? '!border-red-500 focus:!border-red-500' : '!border-[#dddee4] focus:!border-[#dddee4]';

    return (
        <div className="relative">
            <textarea
                className={`${baseClasses} ${borderClasses} ${className}`}
                value={value}
                onChange={handleChange}
                onBlur={onBlur}
                placeholder={placeholder}
                rows={rows}
                maxLength={maxLength}
                style={{ minHeight: `${rows * 1.5 + 1.875}rem` }}
                {...props}
            />
            {showCount && (
                <div className="absolute bottom-2 right-2 text-xs text-[#676c83]">
                    {charCount}
                    {maxLength && `/${maxLength}`}
                </div>
            )}
        </div>
    );
};

export default TextArea;
